import { createActions, createConsts, createReducer } from '../../utils/redux';

export const consts = createConsts(
  'communities',
  'newPostForm',
  'UPDATE_FORM',
  'CLEAR_FORM',
);
export const actions = createActions(consts);

const initialState = {};

export default createReducer(initialState, {
  [consts.UPDATE_FORM]: (state, action) =>
    Object.assign({}, state, { ...action.payload }),
  [consts.CLEAR_FORM]: (state, action) => initialState,
});



// WEBPACK FOOTER //
// ./src/redux/communities/newPostForm.js